import { apiClient } from "@/core/api/ApiClient";
import { AssetSubscriptionDto, EntityType } from "@/core/api/generated/v1";

import BaseEntityDeleteModal, {
  BaseEntityDeleteModalInheritableProps,
} from "../components/BaseEntityDeleteModal";

export interface OwnProps {
  entity: AssetSubscriptionDto;
}

type Props = OwnProps & BaseEntityDeleteModalInheritableProps;

export default function AssetSubscriptionDeleteModal({ entity, ...otherProps }: Props) {
  return (
    <BaseEntityDeleteModal
      entityType={EntityType.AssetSubscription}
      entity={entity}
      entityId={entity.id}
      deleteFunc={async (params) => {
        await apiClient.assetSubscriptionsApi.apiV1AssetSubscriptionsAssetSubscriptionIdDelete({
          nexusOpsTenant: EMPTY_TENANT_IDENTIFIER,
          assetSubscriptionId: params.entityId,
          isDeleteCascade: params.isDeleteCascade,
        });
      }}
      {...otherProps}
    />
  );
}
